/** ----------------------------------------
    Vue
 ---------------------------------------- */

import Vue from 'vue';
import Vuex from 'vuex';

/** ----------------------------------------
     State
 ---------------------------------------- */

import state from './state';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

/** ----------------------------------------
    Settings
 ---------------------------------------- */

import routesModule from '@store/routes/module';
import settingsModule from '@store/settings/module';
import transModule from '@store/trans/module';

/** ----------------------------------------
    Modules
 ---------------------------------------- */

import general from '@store/general/module';
import cases from '@store/cases/module';
import news from '@store/news/module';
import pages from '@store/pages/module';
import teams from '@store/teams/module';
import jobs from '@store/jobs/module';
import templates from '@store/templates/module';

/** ----------------------------------------
    Initiate Vuex
 ---------------------------------------- */

Vue.use(Vuex);

/** ----------------------------------------
    Export State
 ---------------------------------------- */

export default new Vuex.Store({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions,
    modules: {
        routes: routesModule,
        settings: settingsModule,
        trans: transModule,
        jobs: jobs,
        general: general,
        cases: cases,
        news: news,
        pages: pages,
        teams: teams,
        templates: templates
    }
});